import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { colorsPalette } from '../../../../../../shared/ui/styles/colors-palette';
import { useUILogic } from '../../../../shared/providers/UILogicProvider/hooks';
import { LoadingStatus } from '../../../../../../shared/infrastructure/types/common/common-types';
import { QRCode } from '../../../../shared/components/QRCode';

let QRConfirmation = function () {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();
  const coreManager = authorizationUiModule.registerUIManager.coreManager;
  const manager = authorizationUiModule.registerUIManager.coreManager.qrConfirmationManager;

  useEffect(() => {
    if (!manager.isWasRequest) {
      manager.setIsWasRequest(true);
      manager.requestVerification();
    }

    let interval: ReturnType<typeof setTimeout>;
    if (manager.registrationId && !isExpired) {
      interval = setInterval(() => {
        manager.checkCodeByID();
      }, 500);
    }
    return () => clearInterval(interval);
  }, [manager.registrationId, manager.isConfirmationExpired]);

  const isExpired = manager.isConfirmationExpired;
  const qrUrl = manager.confirmationQrUrl;
  const statusQR = !isExpired && qrUrl ? undefined : 'expired';
  const loading = coreManager.verificationPrepareStatus === LoadingStatus.LOADING;

  const handleRefresh = useCallback(() => {
    manager.requestVerification();
  }, [manager]);

  return (
    <QrBlock>
      <QrBox>
        <QRCode
          style={{ marginBottom: 16 }}
          value={qrUrl}
          status={statusQR}
          loading={loading}
          onRefresh={handleRefresh}
          refreshText={t('common.reload') as PlainText}
          loadingText={t('common.loading') as PlainText}
        />
      </QrBox>
      <Timer>
        {isExpired
          ? t(`register.phone.confirm.qr.expired`)
          : t(`register.phone.confirm.qr.valid`, {
              timer: manager.confirmationTimer,
            })}
      </Timer>
      <Instruction>{t('register.phone.confirm.qr.instruction')}</Instruction>
    </QrBlock>
  );
};

const QrBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;
const QrBox = styled.div`
  position: relative;
  padding: 12px;
  border-radius: 8px;
  background: ${colorsPalette.white};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Instruction = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.gray600};
  text-align: center;
  white-space: pre-line;
`;

const Timer = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${colorsPalette.gray600};
  text-align: center;
`;

QRConfirmation = observer(QRConfirmation);

export { QRConfirmation };
